import React, { useState } from "react";
import axios from "axios";
import "./Register.css";

function Register() {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.username ||
      !formData.password ||
      !formData.confirmPassword
    ) {
      alert("Please fill all fields");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      setLoading(true);

      await axios.post("https://hrpsc.swisstekaluminium.com/api/auth/register", {
        username: formData.username.trim(),
        password: formData.password,
      });

      alert("Registration Successful. Please login.");

      window.location.href = "/";
    } catch (err) {
      console.log(err.response?.data || err);

      alert(
        err.response?.data?.message ||
          "Registration Failed"
      );
    } finally {
      setLoading(false);
    }
  };

  const clearForm = () => {
    setFormData({
      username: "",
      password: "",
      confirmPassword: "",
    });
  };

  return (
    <div className="register-container">
      <div className="register-left">
        <div className="register-brand">
          <div className="register-icon">👥</div>

          <h1>Create Your Account</h1>

          <p>
            Join the company dashboard and access your assigned management
            modules securely.
          </p>

          <div className="register-features">
            <span>✅ Secure account creation</span>
            <span>✅ Standard user access</span>
            <span>✅ Admin approval required</span>
          </div>
        </div>
      </div>

      <div className="register-right">
        <form className="register-box" onSubmit={handleSubmit}>
          <div className="form-icon">🏢</div>

          <h2>Sign Up</h2>

          <p className="subtitle">
            Fill the details below to create a user account
          </p>

          <div className="input-group">
            <label>Username</label>

            <input
              type="text"
              name="username"
              placeholder="Enter username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group">
            <label>Password</label>

            <input
              type="password"
              name="password"
              placeholder="Enter password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group">
            <label>Confirm Password</label>

            <input
              type="password"
              name="confirmPassword"
              placeholder="Confirm password"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="register-btn"
            disabled={loading}
          >
            {loading ? "Creating..." : "Sign Up"}
          </button>

          <button
            type="button"
            className="cancel-btn"
            onClick={clearForm}
          >
            Cancel
          </button>

          <div className="login-link">
            Already have an account?
            <a href="/"> Sign In</a>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;